import React, { Fragment } from 'react';

import { Box, Typography } from '@mui/material';
import PendingChangeWrapper from '@sharedCR/common/PendingChangeWrapper';
import PropTypes from 'prop-types';

import { PendingChangesActionType } from 'constants/pendingChanges';
import useModifiedFieldPendingChangeAuthors from 'hooks/useModifiedFieldPendingChangeAuthors';

import { BORROWER_FULL_NAME_FIELD } from '../../FinancialInfo.constants';
import { sharedTypographyStyles } from '../FinancialInfoBody.styles';

import { BORROWER_NAME_FIELD_LABEL } from './BorrowersNames.constants';
import { borrowersNamesWrapperStyles } from './BorrowersNames.styles';

const BorrowersNames = ({
  ownersInfo,
  rowModifiedFields,
  rowPendingChangesActionType,
  typographyStyles = sharedTypographyStyles,
}) => {
  const getModifiedFieldPendingChangeAuthors = useModifiedFieldPendingChangeAuthors();

  return (
    <Box sx={borrowersNamesWrapperStyles}>
      {ownersInfo.map(({ fullName, id, modifiedFields, modifiedFieldDetails }, index) => (
        <Fragment key={id}>
          <PendingChangeWrapper
            isSmall
            authors={getModifiedFieldPendingChangeAuthors(
              modifiedFieldDetails,
              BORROWER_FULL_NAME_FIELD,
            )}
            fieldLabel={BORROWER_NAME_FIELD_LABEL}
            key={id}
            pendingChangesActionType={
              modifiedFields?.includes(BORROWER_FULL_NAME_FIELD) &&
              !rowModifiedFields.includes('OwnersFullNames') &&
              !rowPendingChangesActionType !== PendingChangesActionType.DELETED
                ? PendingChangesActionType.MODIFIED
                : undefined
            }
          >
            <Typography
              data-truncated
              className="truncate"
              sx={typographyStyles}
              variant="regular14"
            >
              {fullName}
            </Typography>
          </PendingChangeWrapper>

          {ownersInfo[index + 1] && <p> & </p>}
        </Fragment>
      ))}
    </Box>
  );
};

BorrowersNames.propTypes = {
  ownersInfo: PropTypes.array.isRequired,
  rowModifiedFields: PropTypes.array.isRequired,
  rowPendingChangesActionType: PropTypes.oneOf(Object.values(PendingChangesActionType)).isRequired,
  typographyStyles: PropTypes.object,
};

export default BorrowersNames;
